import { render, staticRenderFns } from "./SwitchTabPopup.vue?vue&type=template&id=3f74f699"
import script from "./SwitchTabPopup.vue?vue&type=script&lang=js"
export * from "./SwitchTabPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports